// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5127":"8d5738b1","6514":"c1192143"}[chunkId] + ".chunk.css";
};